module.exports = __webpack_public_path__ + "static/media/A2_23.cfbb6fc8.png";